(function() {
    // 注册组件
    SR.component.extend('voiceInput', voiceInput);

    function voiceInput() {
        var $inputBox = $('.input-box');
        var $speechBtn = $('.J_speech');
        var $speechStatus = $('<div class="speech-status"><div class="sound-wave-wrap"><img class="wave-bg" src="dist/theme/immersive/images/light/voice_ai_bg.png" /></div>录音中</div>');
        var $body = SR.dom.$body;
        var onTranslateVoice = false;
        var PRESS_TXT = '按住 说话';
        var ON_PRESS_TXT = '松开结束';
        var VOICE_ERROR_TXT = '语音初始化失败，请刷新重试';
        var VOICE_ERROR_TXT_2 = '语音调用失败，请重试';
        var NO_SPEECH = '未能识别，请重试';
        var resetTimer;
        var pressTimer;
        var isError = false;
        var startRecord = false;
        // TEST
        // SR.data.deviceInfo.isWX = true;
        if (SR.state.wxSpeech && SR.data.deviceInfo.isWX) {
            $inputBox.addClass('showSpeech');
            // 获取 JSSDK 授权
            window.getWxAuth({ linkurl: location.href }, function(err, data) {
                if (err) {
                    if (data && data.code == -102) {
                        window.getWxAuth({ linkurl: location.href }, function(err, data) {
                            if (err) {
                                $speechBtn.addClass('small').text(VOICE_ERROR_TXT);
                                return;
                            }
                            if (data) {
                                setRecordEvent();
                            }
                        });
                    }
                    return;
                }
                if (data) {
                    setRecordEvent();
                }
            });
            // 切换到语音
            $('.J_changeInputMode.voice').on('click', function() {
                var needVoiceAuth = !SR.util.getStorage('voiceAuth');
                if (needVoiceAuth) {
                    // 如果未授权，提前调用语音接口，触发用户授权
                    wx.startRecord();
                    setTimeout(function() {
                        wx.stopRecord();
                    }, 200);
                }
            });
            // 切换到键盘
            $('.J_changeInputMode.keyboard').on('click', function() {
                $body.removeClass('onSpeech');
                $speechBtn.removeClass('on-press');
                wx.stopRecord();
            });

            // 初始化录音事件
            function setRecordEvent() {
                $body.append($speechStatus);
                wx.ready(function() {
                    if (isError) {
                        return;
                    }
                    $speechBtn.on('touchstart', function() {
                        if (!$body.hasClass('onSpeech')) {
                            $(this).text(ON_PRESS_TXT);
                            startSpeech();
                        }
                    }).on('touchend', function() {
                        endSpeech();
                    }).text(PRESS_TXT);
                });
                wx.error(function(res) {
                    $speechBtn.addClass('small').text(VOICE_ERROR_TXT);
                    isError = true;
                });
            }

            function startSpeech() {
                if (startRecord) {
                    wx.stopRecord({
                        complete: function() {
                            onTranslateVoice = false;
                            startRecord = false;
                        }
                    })
                }
                if (pressTimer) {
                    clearTimeout(pressTimer);
                    pressTimer = null;
                }
                if (resetTimer) {
                    clearTimeout(resetTimer);
                    resetTimer = null;
                }
                pressTimer = setTimeout(function() {
                    $body.addClass('onSpeech');
                    $speechBtn.addClass('on-press');
                    wx.startRecord();
                    startRecord = true;
                }, 300);
            }

            function endSpeech() {
                if (pressTimer) {
                    // 过短的点击，不响应录音事件
                    clearTimeout(pressTimer);
                    pressTimer = null;
                }
                $body.removeClass('onSpeech');
                $speechBtn.removeClass('on-press').text(PRESS_TXT);
                if (startRecord) {
                    getTranslateVoice();
                }
            }

            function speechError() {
                $body.removeClass('onSpeech');
                $speechBtn.removeClass('on-press').text(VOICE_ERROR_TXT_2);
                $speechBtn.text(PRESS_TXT);
            }

            function noSpeech() {
                $body.removeClass('onSpeech');
                $speechBtn.removeClass('on-press').text(NO_SPEECH);
                $speechBtn.text(PRESS_TXT);
            }

            // 获取语音文字
            function getTranslateVoice() {
                if (onTranslateVoice) {
                    return;
                }
                onTranslateVoice = true;
                wx.stopRecord({
                    success: function(res) {
                        var localId = res.localId;
                        if (localId) {
                            wx.translateVoice({
                                localId: localId,
                                isShowProgressTips: 1,
                                success: function(res) {
                                    var question = res.translateResult;
                                    if (!SR.util.getStorage('voiceAuth')) {
                                        SR.util.updateStorage('voiceAuth', 1);
                                    }
                                    if (question) {
                                        question = question.replace('。', '');
                                        window.ask(question);
                                    } else {
                                        noSpeech();
                                    }
                                },
                                fail: function() {
                                    speechError();
                                },
                                complete: function() {
                                    onTranslateVoice = false;
                                    startRecord = false;
                                }
                            });
                        }
                    },
                    fail: function() {
                        speechError();
                    },
                    complete: function() {
                        onTranslateVoice = false;
                    }
                });
            }
        }
    }
})();
